import getStore from "../store/store";

const interactions = new Set<symbol>();

export function hasPendingTodayInteraction(): boolean {
    return interactions.size > 0;
}

/** Holds reload while a document-owned open, clipboard operation, or editor handoff settles. */
export function reserveTodayInteraction(): (() => void) | undefined {
    if (getStore().todayDocumentReloading) {
        return undefined;
    }
    const owner = Symbol("TodayInteraction");
    interactions.add(owner);
    return () => interactions.delete(owner);
}
